import { useEffect, useMemo } from 'react';
import { ActivitiesModel } from '../models/ActivitiesModel';

/**
 * The Activities model beside the Library and Assessments models whose
 * changes it logs. It lives as long as they do, so it's rebuilt with them
 * when the user or the active organisation changes. It listens only while
 * mounted, so a model React builds and throws away never subscribes, and a
 * remount (StrictMode's included) listens again. `actor` is the signed-in
 * user's display name.
 */
export const useActivitiesModel = (libraryModel, assessmentsModel, actor) => {
  const model = useMemo(() => new ActivitiesModel(libraryModel, assessmentsModel), [libraryModel, assessmentsModel]);
  useEffect(() => { model.setActor(actor); }, [model, actor]);
  useEffect(() => {
    model.watch();
    return () => model.stop();
  }, [model]);
  return model;
};
